import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Fixed Background */}
      <div className="fixed-background"></div>

      {/* Scrollable Content */}
      <div className="scrollable-content">
        {/* NGO Name */}
        <h1>Satyabhama Nutan Social Welfare Organization</h1>
        <h1>सत्यभामा नूतन समाज कल्याण संगठन</h1>

        {/* Registration Link */}
        <a
          href="https://forms.gle/qSdy42BKhnanAG19A"
          target="_blank"
          rel="noopener noreferrer"
        >
          Register for Free Notebook Distribution / निःशुल्क नोटबुक वितरण के लिए पंजीकरण करें
        </a>

        {/* Embedded YouTube Video */}
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/P9z8tuxHFoQ"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        {/* Mission and Vision Section */}
        <div className="mission-vision-container">
          <div className="mission-box">
            <h2>Mission Statement</h2>
            <p>
              Our mission is to inspire and empower individuals by providing resources, support,
              and opportunities that foster education, personal growth, and community development.
            </p>
            <p>
              हमारा मिशन छात्रों को संसाधन, सहायता और अवसर प्रदान करके प्रेरित और सशक्त बनाना है, जिससे
              शिक्षा, व्यक्तिगत विकास और सामुदायिक विकास को बढ़ावा मिले।
            </p>
          </div>
          <div className="vision-box">
            <h2>Vision Statement</h2>
            <p>
              To create a world where every individual has the opportunity to thrive, contributing
              to a society that values equality, compassion, and sustainable progress.
            </p>
            <p>
              एक ऐसा विश्व बनाना जहां प्रत्येक व्यक्ति को उन्नति करने का अवसर मिले, तथा वह ऐसे समाज में
              योगदान दे सके जो समानता, करुणा और सतत प्रगति को महत्व देता हो।
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
